// import React, { useState, useEffect, useCallback } from 'react';
// import { CircularProgress, Tooltip } from '@mui/material';
// import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
// import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
// import { DayPicker } from 'react-day-picker';
// import { WorkyTimePicker } from '../../common/TimePicker';
// import { useIsMobile } from '../../custom-hooks/useIsMobile';
// import { useSnackbar } from 'notistack';
// import { WorkyTaskType, EmailCalendarTaskDTO } from '../worky-leads-interfaces/WorkyLeadsInterfaces';
// import { RetrieveFromLocalCache, LOCAL_STORAGE_KEYS } from '../../common/CommonUtilsMethods';
// import { SendCalendarTaskAPICall } from '../worky-leads-apis/WorkyLeadsAPIs';
// import './createworkytasks.css';

// interface CreateWorkyTasksProps {
//     readonly onTaskCreated?: () => void;
//     readonly showModal: boolean;
//     readonly onClose: () => void;
// }

// interface WorkyTaskFormData {
//     readonly additionalEmails: readonly string[];
//     readonly selectedDate: Date | null;
//     readonly selectedHour: number;
//     readonly selectedMinute: number;
//     readonly emailHeader: string;
//     readonly emailBody: string;
//     readonly additionalEmailInput: string;
// }

// const CreateWorkyTasks: React.FC<CreateWorkyTasksProps> = ({ onTaskCreated, showModal, onClose }) => {
//     const isMobile = useIsMobile();
//     const { enqueueSnackbar } = useSnackbar();
//     const [showDropdown, setShowDropdown] = useState<boolean>(false);
//     const [selectedTaskType, setSelectedTaskType] = useState<WorkyTaskType | null>(null);
//     const [loading, setLoading] = useState<boolean>(false);

//     const [formData, setFormData] = useState<WorkyTaskFormData>({
//         additionalEmails: [],
//         selectedDate: null,
//         selectedHour: 9,
//         selectedMinute: 0,
//         emailHeader: '',
//         emailBody: '',
//         additionalEmailInput: '',
//     });

//     // Reset form when modal closes
//     useEffect(() => {
//         if (!showModal) {
//             setShowDropdown(false);
//             setSelectedTaskType(null);
//             setFormData({
//                 additionalEmails: [],
//                 selectedDate: null,
//                 selectedHour: 9,
//                 selectedMinute: 0,
//                 emailHeader: '',
//                 emailBody: '',
//                 additionalEmailInput: '',
//             });
//         }
//     }, [showModal]);

//     // Initialize task type when modal opens
//     useEffect(() => {
//         if (showModal) {
//             /**
//              * Commenting this out for now, as Worky Calendar is the default task type. for now. we will add more task types later.
//              */
//             // setShowDropdown(true);
//             setSelectedTaskType(WorkyTaskType.CALENDAR_REMINDER);
//         }
//     }, [showModal]);

//     const handleTaskTypeSelect = (taskType: WorkyTaskType) => {
//         setSelectedTaskType(taskType);        
//         /**
//          * Commenting this out for now, as Worky Calendar is the default task type. for now. we will add more task types later.
//          */
//         // setShowDropdown(false);
//     };

//     const updateFormData = (field: keyof WorkyTaskFormData, value: any) => {
//         setFormData((prev) => ({
//             ...prev,
//             [field]: value,
//         }));
//     };

//     const handleAddEmail = () => {
//         const email = formData.additionalEmailInput?.trim();
//         if (email && email.includes('@')) {
//             if (!formData.additionalEmails.includes(email)) {
//                 updateFormData('additionalEmails', [...formData.additionalEmails, email]);
//                 updateFormData('additionalEmailInput', '');
//             } else {
//                 enqueueSnackbar('Email already exists in the list', { variant: 'warning' });
//             }
//         } else {
//             enqueueSnackbar('Please enter a valid email address', { variant: 'error' });
//         }
//     };

//     const handleRemoveEmail = (emailToRemove: string) => {
//         updateFormData('additionalEmails', formData.additionalEmails.filter(email => email !== emailToRemove));
//     };

//     const handleDateSelect = (date: Date | undefined) => {
//         if (date) {
//             updateFormData('selectedDate', date);
//         }
//     };

//     const handleTimeChange = useCallback((hour: number, minute: number) => {
//         setFormData((prev) => ({
//             ...prev,
//             selectedHour: hour,
//             selectedMinute: minute,
//         }));
//     }, []);

//     const handleTimeChangeHour = useCallback((hour: number) => {
//         setFormData((prev) => ({
//             ...prev,
//             selectedHour: hour,
//         }));
//     }, []);

//     const handleTimeChangeMinute = useCallback((minute: number) => {
//         setFormData((prev) => ({
//             ...prev,
//             selectedMinute: minute,
//         }));
//     }, []);

//     const handleSubmit = async () => {
//         // Validate required fields
//         if (!formData.selectedDate) {
//             enqueueSnackbar('Please select a date', { variant: 'error' });
//             return;
//         }

//         // Check if there's a pending email in the input field
//         const pendingEmail = formData.additionalEmailInput?.trim();
//         let emailsToUse = [...formData.additionalEmails];

//         if (pendingEmail && pendingEmail.includes('@')) {
//             const shouldAddEmail = window.confirm('You have added the following email: ' + pendingEmail + '. Do you want to include it in the task invite?');
//             if (shouldAddEmail) {
//                 // Add the email to the list if it doesn't already exist
//                 if (!emailsToUse.includes(pendingEmail)) {
//                     emailsToUse = [...emailsToUse, pendingEmail];
//                     updateFormData('additionalEmails', emailsToUse);
//                     updateFormData('additionalEmailInput', '');
//                 } else {
//                     // enqueueSnackbar('Email already exists in the list', { variant: 'warning' });
//                     updateFormData('additionalEmailInput', '');
//                 }
//             } else {
//                 // Clear the pending email input if user chooses not to add it
//                 updateFormData('additionalEmailInput', '');
//             }
//         }

//         try {
//             setLoading(true);

//             // Get account email
//             const accountEmail = RetrieveFromLocalCache(LOCAL_STORAGE_KEYS.USER_EMAIL);

//             // Combine account email with additional emails (using emailsToUse which may include the pending email)
//             const toEmailAddresses: readonly string[] = accountEmail 
//                 ? [...emailsToUse, accountEmail]
//                 : emailsToUse;

//             // Create date object with selected date and time
//             const dateTime = new Date(formData.selectedDate);
//             dateTime.setHours(formData.selectedHour, formData.selectedMinute, 0, 0);

//             // Convert to EST epoch seconds
//             const estEpochTime = new Date(dateTime.toLocaleString('en-US', { timeZone: 'America/New_York' }));
//             const epochDateTimeSecondsESTForCalendar = Math.floor(estEpochTime.getTime() / 1000);

//             // Prepare request data
//             const requestData: EmailCalendarTaskDTO = {
//                 toEmailAddresses: toEmailAddresses,
//                 emailHeader: formData.emailHeader || '',
//                 messageNote: formData.emailBody || '',
//                 epochDateTimeSecondsESTForCalendar: epochDateTimeSecondsESTForCalendar,
//             };

//             // Call API
//             const result = await SendCalendarTaskAPICall(requestData);

//             if (result) {
//                 enqueueSnackbar('Worky task created successfully!', { variant: 'success' });
//                 onClose();

//                 if (onTaskCreated) {
//                     onTaskCreated();
//                 }
//             } else {
//                 enqueueSnackbar('Error creating worky task. Please try again.', { variant: 'error' });
//             }
//         } catch (error) {
//             console.error('Error creating worky task:', error);
//             enqueueSnackbar('Error creating worky task. Please try again.', { variant: 'error' });
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleClose = () => {
//         onClose();
//     };

//     return (
//         <div className={isMobile ? 'create-worky-task-modal-mobile' : 'create-worky-task-modal'}>
//             {isMobile ? (
//                 <button onClick={handleClose} className="timeclock-close-mobile" />
//             ) : (
//                 <button onClick={handleClose} className="agency-billing-close">
//                     <CloseRoundedIcon />
//                 </button>
//             )}
//             <div className={isMobile ? 'org-jobber-workforce-modal-section worky-task-modal-section-mobile' : 'org-jobber-workforce-modal-section worky-task-modal-section'}>
//                         <div className="agency-billing-modal-title worky-task-modal-title">
//                             <CalendarTodayIcon sx={{ fontSize: '24px', marginRight: '8px' }} />
//                             Create Worky Tasks
//                         </div>

//                         {loading ? (
//                             <div className="worky-task-loading-container">
//                                 <CircularProgress size={60} thickness={5} style={{ color: '#2c68bd' }} />
//                             </div>
//                         ) : (
//                             <>
//                                 {showDropdown && !selectedTaskType && (
//                                     <div className="worky-task-type-dropdown">
//                                         <div className="worky-form-generation-field-header">Select Task Type</div>
//                                         <select
//                                             className={isMobile ? 'worky-lead-status-select-mobile' : 'worky-lead-status-select'}
//                                             onChange={(e) => {
//                                                 const value = e.target.value;
//                                                 if (value) {
//                                                     handleTaskTypeSelect(value as WorkyTaskType);
//                                                 }
//                                             }}
//                                             value=""
//                                         >
//                                             <option value="">Select a task type...</option>
//                                             <option value={WorkyTaskType.CALENDAR_REMINDER}>Calendar Reminder</option>
//                                         </select>
//                                     </div>
//                                 )}

//                                 {selectedTaskType === WorkyTaskType.CALENDAR_REMINDER && (
//                                     <div className="create-worky-task-form-content">
//                                         {/* Account Email Message */}
//                                         <div className="create-worky-task-email-section">
//                                             <div className="worky-task-info-box">
//                                                 <div className="worky-task-info-message">
//                                                     <span>ℹ️</span>
//                                                     <span>Your account email ({RetrieveFromLocalCache(LOCAL_STORAGE_KEYS.USER_EMAIL) || 'your email'}) will also be emailed and invited.</span>
//                                                 </div>
//                                             </div>

//                                             {/* Additional Email Addresses */}
//                                             <div>
//                                                 <div className="create-worky-task-email-label worky-task-email-label-row">
//                                                     <span>Additional Email Addresses</span>
//                                                     {formData.additionalEmailInput && (
//                                                         <button
//                                                             type="button"
//                                                             onClick={handleAddEmail}
//                                                             className="worky-task-add-email-btn"
//                                                         >
//                                                             Add Email
//                                                         </button>
//                                                     )}
//                                                 </div>
//                                                 <input
//                                                     type="email"
//                                                     className={isMobile ? 'worky-form-input-mobile' : 'worky-form-input'}
//                                                     placeholder="Enter email address"
//                                                     value={formData.additionalEmailInput}
//                                                     onChange={(e) => updateFormData('additionalEmailInput', e.target.value)}
//                                                     onKeyDown={(e) => {
//                                                         if (e.key === 'Enter') {
//                                                             e.preventDefault();
//                                                             handleAddEmail();
//                                                         }
//                                                     }}
//                                                 />
//                                                 {formData.additionalEmails.length > 0 && (
//                                                     <div className="worky-task-email-chips-container">
//                                                         {formData.additionalEmails.map((email, index) => (
//                                                             <span
//                                                                 key={`email-${index}`}
//                                                                 className="worky-task-email-chip"
//                                                             >
//                                                                 {email}
//                                                                 <button
//                                                                     type="button"
//                                                                     onClick={() => handleRemoveEmail(email)}
//                                                                     className="worky-task-remove-email-btn"
//                                                                 >
//                                                                     ×
//                                                                 </button>
//                                                             </span>
//                                                         ))}
//                                                     </div>
//                                                 )}
//                                             </div>
//                                         </div>

//                                         {/* Calendar Picker */}
//                                         <div className="worky-task-calendar-section">
//                                             <div className="create-worky-task-section-header">Select Date</div>
//                                             <div className={isMobile ? 'worky-calendar-holder-mobile' : 'worky-calendar-holder'}>
//                                                 <DayPicker
//                                                     mode="single"
//                                                     selected={formData.selectedDate ?? undefined}
//                                                     onSelect={handleDateSelect}
//                                                     className="worky-day-picker"
//                                                     modifiersStyles={{
//                                                         selected: { 
//                                                             backgroundColor: '#2c68bd',
//                                                             color: 'white',
//                                                             border: '2px solid #2c68bd',
//                                                             fontWeight: '600'
//                                                         },
//                                                     }}
//                                                 />
//                                             </div>
//                                         </div>

//                                         {/* Time Picker */}
//                                         <div className="worky-task-calendar-section">
//                                             <div className="create-worky-task-section-header">Select Time</div>
//                                             <div className="worky-task-time-picker-container">
//                                                 <div className="worky-task-time-picker-wrapper">
//                                                     <WorkyTimePicker
//                                                         onFinalTimeChangeHour={handleTimeChangeHour}
//                                                         onFinalTimeChangeMinute={handleTimeChangeMinute}
//                                                     />
//                                                     <Tooltip title="The time of the calendar invite will be in EST" arrow>
//                                                         <div className="worky-est-label">
//                                                             EST
//                                                         </div>
//                                                     </Tooltip>
//                                                 </div>
//                                             </div>
//                                         </div>

//                                         {/* Optional Email Header and Message Body */}
//                                         <div>
//                                             <div className="create-worky-task-section-header">Task Details</div>

//                                             {/* Email Header Field */}
//                                             <div className="worky-task-details-field">
//                                                 <div className="create-worky-task-email-label worky-task-field-label">
//                                                     Email Header (Optional)
//                                                 </div>
//                                                 <input
//                                                     type="text"
//                                                     className={isMobile ? 'worky-form-input-mobile' : 'worky-form-input'}
//                                                     placeholder="Enter email header"
//                                                     value={formData.emailHeader}
//                                                     onChange={(e) => updateFormData('emailHeader', e.target.value)}
//                                                 />
//                                             </div>

//                                             {/* Message Body Field */}
//                                             <div className="worky-task-details-field">
//                                                 <div className="create-worky-task-email-label worky-task-field-label">
//                                                     Message Body (Optional)
//                                                 </div>
//                                                 <textarea
//                                                     className={isMobile ? 'worky-form-textarea-mobile' : 'worky-form-textarea'}
//                                                     placeholder="Enter message body"
//                                                     value={formData.emailBody}
//                                                     onChange={(e) => updateFormData('emailBody', e.target.value)}
//                                                     rows={5}
//                                                 />
//                                             </div>
//                                         </div>

//                                         {/* Submit Button */}
//                                         <div className="worky-task-submit-container">
//                                             <button
//                                                 type="button"
//                                                 onClick={handleSubmit}
//                                                 className={isMobile ? 'worky-form-submit-btn-mobile' : 'worky-form-submit-btn'}
//                                                 disabled={loading}
//                                             >
//                                                 Create Task
//                                             </button>
//                                         </div>
//                                     </div>
//                                 )}
//                             </>
//                         )}
//                     </div>
//                 </div>
//     );
// };

// export { CreateWorkyTasks };





import React, { useState, useEffect, useCallback } from 'react';
import { CircularProgress, Tooltip, Paper } from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { DayPicker } from 'react-day-picker';
import { WorkyTimePicker } from '../../common/TimePicker';
import { useIsMobile } from '../../custom-hooks/useIsMobile';
import { useSnackbar } from 'notistack';
import { WorkyTaskType, EmailCalendarTaskDTO, SimpleTargetLeadSellerClientViewDTO } from '../worky-leads-interfaces/WorkyLeadsInterfaces';
import { RetrieveFromLocalCache, LOCAL_STORAGE_KEYS } from '../../common/CommonUtilsMethods';
import { SendCalendarTaskAPICall } from '../worky-leads-apis/WorkyLeadsAPIs';
import './createworkytasks.css';
import { CalendarPlus2, Plus } from 'lucide-react';

interface CreateWorkyTasksProps {
    readonly onTaskCreated?: () => void;
    readonly showModal: boolean;
    readonly onClose: () => void;
    readonly simpleTargetLeadSellerClientView?: SimpleTargetLeadSellerClientViewDTO;
}

interface WorkyTaskFormData {
    readonly additionalEmails: readonly string[];
    readonly selectedDate: Date | null;
    readonly selectedHour: number;
    readonly selectedMinute: number;
    readonly emailHeader: string;
    readonly emailBody: string;
    readonly additionalEmailInput: string;
}

const CreateWorkyTasks: React.FC<CreateWorkyTasksProps> = ({ onTaskCreated, showModal, onClose, simpleTargetLeadSellerClientView }) => {
    const isMobile = useIsMobile();
    const { enqueueSnackbar } = useSnackbar();
    const [showDropdown, setShowDropdown] = useState<boolean>(false);
    const [selectedTaskType, setSelectedTaskType] = useState<WorkyTaskType | null>(null);
    const [loading, setLoading] = useState<boolean>(false);

    const [formData, setFormData] = useState<WorkyTaskFormData>({
        additionalEmails: [],
        selectedDate: null,
        selectedHour: 9,
        selectedMinute: 0,
        emailHeader: '',
        emailBody: '',
        additionalEmailInput: '',
    });

    // Reset form when modal closes
    useEffect(() => {
        if (!showModal) {
            setShowDropdown(false);
            setSelectedTaskType(null);
            setFormData({
                additionalEmails: [],
                selectedDate: null,
                selectedHour: 9,
                selectedMinute: 0,
                emailHeader: '',
                emailBody: '',
                additionalEmailInput: '',
            });
        }
    }, [showModal]);

    // Initialize task type when modal opens
    useEffect(() => {
        if (showModal) {
            /**
             * Commenting this out for now, as Worky Calendar is the default task type. for now. we will add more task types later.
             */
            // setShowDropdown(true);
            setSelectedTaskType(WorkyTaskType.CALENDAR_REMINDER);
        }
    }, [showModal]);

    const handleTaskTypeSelect = (taskType: WorkyTaskType) => {
        setSelectedTaskType(taskType);
        /**
         * Commenting this out for now, as Worky Calendar is the default task type. for now. we will add more task types later.
         */
        // setShowDropdown(false);
    };

    const updateFormData = (field: keyof WorkyTaskFormData, value: any) => {
        setFormData((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    const handleAddEmail = () => {
        const email = formData.additionalEmailInput?.trim();
        if (email && email.includes('@')) {
            if (!formData.additionalEmails.includes(email)) {
                updateFormData('additionalEmails', [...formData.additionalEmails, email]);
                updateFormData('additionalEmailInput', '');
            } else {
                enqueueSnackbar('Email already exists in the list', { variant: 'warning' });
            }
        } else {
            enqueueSnackbar('Please enter a valid email address', { variant: 'error' });
        }
    };

    const handleRemoveEmail = (emailToRemove: string) => {
        updateFormData('additionalEmails', formData.additionalEmails.filter(email => email !== emailToRemove));
    };

    const handleDateSelect = (date: Date | undefined) => {
        if (date) {
            updateFormData('selectedDate', date);
        }
    };

    const handleTimeChange = useCallback((hour: number, minute: number) => {
        setFormData((prev) => ({
            ...prev,
            selectedHour: hour,
            selectedMinute: minute,
        }));
    }, []);

    const handleTimeChangeHour = useCallback((hour: number) => {
        setFormData((prev) => ({
            ...prev,
            selectedHour: hour,
        }));
    }, []);

    const handleTimeChangeMinute = useCallback((minute: number) => {
        setFormData((prev) => ({
            ...prev,
            selectedMinute: minute,
        }));
    }, []);

    const handleSubmit = async () => {
        // Validate required fields
        if (!formData.selectedDate) {
            enqueueSnackbar('Please select a date', { variant: 'error' });
            return;
        }

        // Check if there's a pending email in the input field
        const pendingEmail = formData.additionalEmailInput?.trim();
        let emailsToUse = [...formData.additionalEmails];

        if (pendingEmail && pendingEmail.includes('@')) {
            const shouldAddEmail = window.confirm('You have added the following email: ' + pendingEmail + '. Do you want to include it in the task invite?');
            if (shouldAddEmail) {
                // Add the email to the list if it doesn't already exist
                if (!emailsToUse.includes(pendingEmail)) {
                    emailsToUse = [...emailsToUse, pendingEmail];
                    updateFormData('additionalEmails', emailsToUse);
                    updateFormData('additionalEmailInput', '');
                } else {
                    // enqueueSnackbar('Email already exists in the list', { variant: 'warning' });
                    updateFormData('additionalEmailInput', '');
                }
            } else {
                // Clear the pending email input if user chooses not to add it
                updateFormData('additionalEmailInput', '');
            }
        }

        try {
            setLoading(true);

            // Get account email
            const accountEmail = RetrieveFromLocalCache(LOCAL_STORAGE_KEYS.USER_EMAIL);

            // Combine account email with additional emails (using emailsToUse which may include the pending email)
            const toEmailAddresses: readonly string[] = accountEmail
                ? [...emailsToUse, accountEmail]
                : emailsToUse;

            // Create date object with selected date and time
            const dateTime = new Date(formData.selectedDate);
            dateTime.setHours(formData.selectedHour, formData.selectedMinute, 0, 0);

            // Convert to EST epoch seconds
            const estEpochTime = new Date(dateTime.toLocaleString('en-US', { timeZone: 'America/New_York' }));
            const epochDateTimeSecondsESTForCalendar = Math.floor(estEpochTime.getTime() / 1000);

            // Prepare request data
            const requestData: EmailCalendarTaskDTO = {
                toEmailAddresses: toEmailAddresses,
                emailHeader: formData.emailHeader || '',
                messageNote: formData.emailBody || '',
                epochDateTimeSecondsESTForCalendar: epochDateTimeSecondsESTForCalendar,
                browserRequestURL: window.location.href,
                ...(simpleTargetLeadSellerClientView && { simpleTargetLeadSellerClientView }),
            };

            // Call API
            const result = await SendCalendarTaskAPICall(requestData);

            if (result) {
                enqueueSnackbar('Worky task created successfully!', { variant: 'success' });
                onClose();

                if (onTaskCreated) {
                    onTaskCreated();
                }
            } else {
                enqueueSnackbar('Error creating worky task. Please try again.', { variant: 'error' });
            }
        } catch (error) {
            console.error('Error creating worky task:', error);
            enqueueSnackbar('Error creating worky task. Please try again.', { variant: 'error' });
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        onClose();
    };

    return (
        <div className={isMobile ? 'create-worky-task-popper-mobile' : 'worky-navigation-dropdown'}>



            <div className="popper-title">
                <CalendarPlus2 size={18} />
                Create Worky Task
            </div>




            {loading ? (
                <div className="worky-task-loading-container">
                    <CircularProgress size={60} thickness={5} style={{ color: '#2c68bd' }} />
                </div>
            ) : (
                <>
                    {showDropdown && !selectedTaskType && (
                        <div className="worky-task-type-dropdown">
                            <div className="worky-form-generation-field-header">Select Task Type</div>
                            <select
                                className={isMobile ? 'worky-lead-status-select-mobile' : 'worky-lead-status-select'}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (value) {
                                        handleTaskTypeSelect(value as WorkyTaskType);
                                    }
                                }}
                                value=""
                            >
                                <option value="">Select a task type...</option>
                                <option value={WorkyTaskType.CALENDAR_REMINDER}>Calendar Reminder</option>
                            </select>
                        </div>
                    )}

                    {selectedTaskType === WorkyTaskType.CALENDAR_REMINDER && (
                        <div className={isMobile ? 'create-worky-task-form-content-mobile' : 'create-worky-task-form-content'}>


                            {/* Account Email Message */}
                            <div className="create-worky-task-email-section">
                                <div className="worky-task-info-box">
                                    <div className="worky-task-info-message">
                                        <span>Your account email ({RetrieveFromLocalCache(LOCAL_STORAGE_KEYS.USER_EMAIL) || 'your email'}) will also be emailed and invited.</span>
                                    </div>
                                </div>

                                {/* Additional Email Addresses */}
                                <div>
                                    <div className="create-worky-task-email-label worky-task-email-label-row">
                                        <span className="popper-subtitle">Additional Email Addresses</span>
                                        {formData.additionalEmailInput && (
                                            <button
                                                type="button"
                                                onClick={handleAddEmail}
                                                className="worky-task-add-email-btn"
                                            >
                                                <Plus size={12} /> Add Email
                                            </button>
                                        )}
                                    </div>
                                    <input
                                        type="email"
                                        className={isMobile ? 'worky-form-input-mobile' : 'worky-form-input'}
                                        placeholder="Enter email address"
                                        value={formData.additionalEmailInput}
                                        onChange={(e) => updateFormData('additionalEmailInput', e.target.value)}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                e.preventDefault();
                                                handleAddEmail();
                                            }
                                        }}
                                    />
                                    {formData.additionalEmails.length > 0 && (
                                        <div className="worky-task-email-chips-container">
                                            {formData.additionalEmails.map((email, index) => (
                                                <span
                                                    key={`email-${index}`}
                                                    className="worky-task-email-chip"
                                                >
                                                    {email}
                                                    <button
                                                        type="button"
                                                        onClick={() => handleRemoveEmail(email)}
                                                        className="worky-task-remove-email-btn"
                                                    >
                                                        ×
                                                    </button>
                                                </span>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className={isMobile ? 'worky-task-calendar-time-picker-mobile' : 'worky-task-calendar-time-picker'}>

                                {/* Calendar Picker */}
                                <div className="worky-task-calendar-section">
                                    <div className="popper-subtitle">Select Date</div>
                                    <div style={{ padding: '0px' }} className={isMobile ? 'worky-calendar-holder-mobile' : 'worky-calendar-holder'}>
                                        <DayPicker
                                            mode="single"
                                            selected={formData.selectedDate ?? undefined}
                                            onSelect={handleDateSelect}
                                            className="worky-day-picker"
                                            modifiers={{ today: new Date() }}
                                            modifiersStyles={{
                                                today: {
                                                    fontWeight: 900,
                                                    color: '#2c68bd',
                                                    fontStyle: 'italic'
                                                },
                                                selected: {
                                                    backgroundColor: '#2c68bd',
                                                    color: 'white',
                                                    border: '2px solid #2c68bd',
                                                    fontWeight: 600
                                                }
                                            }}
                                        />
                                    </div>
                                </div>



                                {/* Time Picker */}
                                <div className="worky-task-calendar-section">
                                    <div className="popper-subtitle">Select Time</div>
                                    <div className="worky-task-time-picker-container">
                                        <div className="worky-task-time-picker-wrapper">
                                            <WorkyTimePicker
                                                onFinalTimeChangeHour={handleTimeChangeHour}
                                                onFinalTimeChangeMinute={handleTimeChangeMinute}
                                            />
                                            <Tooltip title="The time of the calendar invite will be in EST" arrow>
                                                <div className="worky-est-label">
                                                    EST
                                                </div>
                                            </Tooltip>
                                        </div>
                                    </div>
                                </div>
                            </div>



                            {/* Optional Email Header and Message Body */}
                            <div>
                                {/* <div className="create-worky-task-section-header">Task Details</div> */}

                                {/* Email Header Field */}
                                <div className="worky-task-details-field">
                                    <div className="popper-subtitle">
                                        Email Header (Optional)
                                    </div>
                                    <input
                                        type="text"
                                        className={isMobile ? 'worky-form-input-mobile' : 'worky-form-input'}
                                        placeholder="Enter email header"
                                        value={formData.emailHeader}
                                        onChange={(e) => updateFormData('emailHeader', e.target.value)}
                                    />
                                </div>

                                {/* Message Body Field */}
                                <div className="worky-task-details-field">
                                    <div className="popper-subtitle">
                                        Message Body (Optional)
                                    </div>
                                    <textarea
                                        className={isMobile ? 'worky-form-textarea-mobile' : 'worky-form-textarea'}
                                        placeholder="Enter message body"
                                        value={formData.emailBody}
                                        onChange={(e) => updateFormData('emailBody', e.target.value)}
                                        rows={3}
                                    />
                                </div>
                            </div>



                            {/* Submit Button */}
                            <div className="worky-task-submit-container">
                                <button
                                    type="button"
                                    onClick={handleSubmit}
                                    className={isMobile ? 'worky-form-submit-btn-mobile' : 'worky-form-submit-btn'}
                                    disabled={loading}
                                >
                                    Create Task
                                </button>
                            </div>




                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export { CreateWorkyTasks };